import { PageNameText } from "../../molecules/PageNameText.tsx";
import { SocialMediaLink } from "../../molecules/SocialMediaLink";

export const Contacts = () => {
  return (
    <div className="flex flex-col bg-black px-10 pb-10 pt-5 text-white">
      <PageNameText text="Contacts" />
      <div className="flex flex-col lg:flex-row">
        <div className="mb-5 ml-auto mr-10 mt-10 flex flex-col">
          <div className="mb-20 mt-auto">
            <a
              href="mailto:joydealto@gmail.com"
              className="text-4xl font-bold text-orange-200 hover:text-orange-100"
            >
              joydealto@gmail.com
            </a>
          </div>
          <span className="mb-auto ml-16 text-2xl font-bold sm:text-3xl">
            SEND ME AN EMAIL IF YOU HAVE A PROJECT
          </span>
        </div>
        <div className="mx-auto mb-10 mr-auto mt-10 rounded-md border-4 border-cream-700 p-5 text-4xl md:text-4xl">
          <div className="flex pb-4 pl-4 md:pl-8">
            <span className="mr-2 block">HEIGHT -</span>
            <span className="text-cream-700">194</span>
          </div>
          <div className="flex pb-4 pl-20 md:pl-36">
            <span className="mr-2 block">WAIST -</span>
            <span className="text-cream-700">90</span>
          </div>
          <div className="flex pb-4 pl-4 md:pl-8">
            <span className="mr-2 block">HIPS -</span>
            <span className="text-cream-700">90</span>
          </div>
          <div className="flex pb-4 pl-20 md:pl-36">
            <span className="mr-2 block">SHOES -</span>
            <span className="text-cream-700">47</span>
          </div>
          <div className="flex pb-4 pl-4 md:pl-8">
            <span className="mr-2 block">EYES -</span>
            <span className="text-cream-700">BROWN</span>
          </div>
          <div className="flex text-nowrap pb-4 pl-20 md:pl-36">
            <span className="mr-2 block">HAIR -</span>
            <span className="text-cream-700">BLOND</span>
          </div>
        </div>
      </div>

      <div className="mx-auto mt-10 flex flex-col">
        <span className="text-3xl sm:-ml-48">CHECK OUT MY OTHER CONTENT:</span>
        <div className="mt-14 flex sm:-ml-5">
          <SocialMediaLink
            link="https://www.instagram.com/joybigman/"
            icon="instagram"
            className="mr-8"
            iconClassName="w-12"
          />
          <SocialMediaLink
            link="https://www.facebook.com/profile.php?id=61566530387861"
            icon="facebook"
            className="mr-8"
            iconClassName="w-12"
          />
          <SocialMediaLink
            link="https://www.tiktok.com/@dziugasjoy"
            icon="tiktok"
            iconClassName="w-14"
            className="mr-5"
          />
        </div>
      </div>
      <div className="mx-auto mt-10 max-w-7xl">
        <img
          className="max-h-screen w-full"
          src={"/photos/home/contacts/contacts.jpg"}
          alt="contactsPhoto"
          loading="lazy"
        />
      </div>
    </div>
  );
};
